import IndexPage from '../../../components/rql/IndexPage.jsx';
import InlineComponent from './inlineComponent.jsx';

module.exports = class filtersIndexPage extends InlineComponent {
  define() {
    this.component = IndexPage;
  }
};
